import moment from "moment";
import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { createCrudActions } from '../utils/crudGenerator';

const formatHolidays = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        date: item.date && moment(item.date),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchHolidays,
    create: createHoliday,
    update: updateHoliday,
    delete: deleteHolidays
} = createCrudActions('HOLIDAY', "Festivo", formatHolidays);

export const syncHolidays = (year) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API.holidays.sync}/${year}`);

            // Refrescar la lista de festivos después de sincronizar
            dispatch(fetchHolidays());

            return response.data;
        } catch (error) {
            console.error("Error syncing holidays:", error);
            throw error;
        }
    };
};
